module.exports = __webpack_public_path__ + "img/icon_copy_white.0510a3b0.png";